import React, { memo } from 'react'
import { Helmet } from 'react-helmet'

import CKDLendingPage from './index'

const CKDRoute = () => {
  return (
    <>
      <Helmet>
        <title>Zydus Life Ka Filter</title>
        <meta name="description" content="Zydus Life Ka Filter" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="Zydus, Zydus Lifekafilter, Zydus Life Ka Filter, Zydus Lifeka filter, zyduslifekafilter, zydus, zydus lifekafilter, zydus life ka filter, zydus lifeka filter, zydus life filter"
        />
        <link rel="canonical" href="https://zyduslifekafilter.com/" />
        <meta property="og:title" content="Zydus Life Ka Filter" />
        <meta property="og:description" content="Zydus Life Ka Filter" />
        <meta property="og:url" content="https://zyduslifekafilter.com/" />
        <meta property="og:type" content="website" />
      </Helmet>

      <CKDLendingPage />
    </>
  )
}

export default memo(CKDRoute)
